import CityPageTemplate from "../city-template/CityPageTemplate";
import { woodbridgeVaConfig } from "./data";

export default function WoodbridgeVaPage() {
  return <CityPageTemplate config={woodbridgeVaConfig} />;
}